import authAxios, { authHeader } from "../data";

const generateHistoryReport = async (
  request: any,
  contractNumber: number,
  name: string,
) => {
  const result = await authAxios.post(
    `/api/Accesses/${contractNumber}/Reports/${name}`,
    request,
    {
      headers: authHeader(),
    },
  );

  return result.data;
};

const download = async (id: string) => {
  const response = await authAxios.get(`/api/Accesses/Reports/${id}/Download`, {
    headers: authHeader(),
    responseType: "blob",
  });
  return response.data;
};

const UserReportService = {
  generateHistoryReport,
  download,
};

export default UserReportService;
